import React from "react";

const Image = ({ image, isVertical }) => {
  const { source, title, route } = image;
  let imageSource = source;
  if (isVertical) {
    imageSource = `${source}_v`;
  }

  return (
    <div>
      <div className="image-content">
        <div className="image-content__bottom">
          <div className="subtitle">{title}</div>
          <div className="subtitle">
            <div className="subtitle">
              <a href={`${route}`}>
                <button className="img-button">Saznajte više</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <img className="image" src={`/images/${imageSource}.jpg`} alt="triotim" />
    </div>
  );
};

export default Image;
